(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["folder-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.afcReady === '1') return;
    root.dataset.afcReady = '1';

    var toggle = root.querySelector('[data-afc-toggle]');
    var closeBtn = root.querySelector('[data-afc-close]');
    if (!toggle) return;

    function open() {
      root.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function close() {
      root.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }
    function flip() {
      root.classList.contains('is-open') ? close() : open();
    }

    toggle.addEventListener('click', flip);
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close();
        toggle.focus();
      });
    }
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) {
        close();
        toggle.focus();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-afc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor re-render support
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-afc]');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
